/* eslint-disable no-console */
import { IS_DEV } from "./config";

export const warn = (...args) => {
  if (IS_DEV) console.warn("[analytics]", ...args);
};
